// extracted by mini-css-extract-plugin
export default {"container":"formLayout_container__z0Vmo","pasted__text":"formLayout_pasted__text__td3Fi","form__loading":"formLayout_form__loading__iKu4E"};